var _path, _rect, _path2, _circle, _path3, _path4, _path5, _circle2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLargeImage = function SvgLargeImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 727 622",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M495.534 165.195 271.212 327.649a55.692 55.692 0 0 0-12.443 77.769l2.65 3.661a55.693 55.693 0 0 0 77.769 12.443L563.51 259.068a55.693 55.693 0 0 0 12.443-77.769l-2.65-3.661a55.696 55.696 0 0 0-36.307-22.328 55.697 55.697 0 0 0-41.462 9.885Z",
    fill: "#F98971"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 628.34,
    y: 273.891,
    width: 99.035,
    height: 99.035,
    rx: 14.599,
    transform: "rotate(5.467 628.34 273.891)",
    fill: "#DFF994"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m671.742 308.775 4.199 13.159-5.072 7.614-.119.202-9.946-.951-2.994 5.459-5.694-.544 13.932-25.483 5.694.544Zm11.796 7.833 6.747 15.97a9.363 9.363 0 1 1-16.657-1.196l.238-.376 9.672-14.398Zm-19.76 6.729 4.481-8.191 2.846 8.892-7.327-.701Z",
    fill: "#00935F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 361.894,
    cy: 92.894,
    r: 70.408,
    transform: "rotate(10.153 361.894 92.894)",
    fill: "#D8E2EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.803 57.787a17.384 17.384 0 0 0-20.176 14.048l-.741 4.14a6.249 6.249 0 0 0-6.528 5.135l-4.405 24.599a6.248 6.248 0 0 0 5.049 7.251l32.798 5.873a6.247 6.247 0 0 0 7.251-5.048l4.405-24.6a6.248 6.248 0 0 0-4.346-7.083l.741-4.139a17.384 17.384 0 0 0-14.048-20.176Zm7.789 23.286.734-4.099a11.772 11.772 0 0 0-23.174-4.15l-.734 4.099 23.174 4.15Z",
    fill: "#9EB4CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m198.558 191.569-43.402 21.501h.001l17.415-8.628c14.351-7.109 31.749-1.239 38.859 13.113l13.672 27.597c7.11 14.352 1.24 31.75-13.112 38.86l-60.817 30.129-12.873-25.986c7.109 14.351 1.239 31.749-13.113 38.859l-20.363 10.089c-14.352 7.11-31.75 1.239-38.86-13.112L12.874 216.824c-7.11-14.352-1.24-31.75 13.112-38.86l46.35-22.962 19.122 38.599.015-.013c-9.983-21.733-.927-47.607 20.647-58.295l47.018-23.294 39.42 79.57Z",
    fill: "#00524E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m570.888 562.629-38.323-30.615 26.525-26.115a9.085 9.085 0 0 0 2.345-9.032 9.031 9.031 0 0 0-6.816-6.344l-124.048-26.745a9.154 9.154 0 0 0-8.993 3.153c-2.17 2.651-2.617 6.313-1.232 9.453l51.836 115.377c1.38 3.031 4.28 5.08 7.605 5.325 3.325.245 6.53-1.326 8.328-4.141l20.033-30.982 38.513 30.752c1.779 1.446 3.957 2.072 6.101 1.972a9.13 9.13 0 0 0 6.652-3.371l12.836-15.932c1.514-1.892 2.239-4.293 1.945-6.683-.258-2.391-1.489-4.591-3.345-6.107l.038.035Z",
    fill: "#FED980"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.592,
    cy: 529.592,
    r: 56.592,
    fill: "#8FA3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.709 502.039c.75 0 1.397.53 1.544 1.266l.34 1.698a7.876 7.876 0 0 0 6.178 6.178l1.697.339a1.575 1.575 0 0 1 0 3.089l-1.697.34a7.873 7.873 0 0 0-6.178 6.178l-.34 1.697a1.575 1.575 0 0 1-3.089 0l-.339-1.697a7.876 7.876 0 0 0-6.178-6.178l-1.698-.34a1.575 1.575 0 0 1 0-3.089l1.698-.339a7.878 7.878 0 0 0 6.178-6.178l.339-1.698a1.576 1.576 0 0 1 1.545-1.266ZM213.657 511.49c.711 0 1.333.475 1.52 1.16l1.41 5.169a20.475 20.475 0 0 0 14.367 14.367l5.169 1.41a1.576 1.576 0 0 1 0 3.039l-5.169 1.41a20.477 20.477 0 0 0-14.367 14.367l-1.41 5.169a1.574 1.574 0 0 1-3.039 0l-1.41-5.169a20.477 20.477 0 0 0-14.367-14.367l-5.169-1.41a1.574 1.574 0 0 1 0-3.039l5.169-1.41a20.475 20.475 0 0 0 14.367-14.367l1.41-5.169a1.574 1.574 0 0 1 1.519-1.16Z",
    fill: "#fff"
  })));
};
export default SvgLargeImage;